import { useEffect } from "react";
import { usePageLocation } from "../routes/AppRoutes";

function ScrollToTop() {
  // The page location beneath any open modal — opening/closing a collection or
  // content dialog must not scroll the page underneath it back to the top.
  const { pathname } = usePageLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
